import React, { useEffect } from "react";
import { useAuth, useNavigation } from "react-uicomp";
import CardWrapper from "../hoc/compWrapper/CardWrapper.hoc";
import CompWrapper from "../hoc/compWrapper/CompWrapper.hoc";
import { DetailCarousel } from "../common/detailCarousel/DetailCarousel.common";
import ActivityIndicator from "../hoc/activityIndicator/ActivityIndicator.hoc";
import { getCurrentLanguage } from "../../utils/getCurrentLanguage.util";

// ACTIONs
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getNewsDetailAction } from "../../actions/Actions";

const NewsDetailPage = (props) => {
  const { setHeaderTitle, language } = useAuth();
  const { params } = useNavigation();
  const { id } = params;
  const { getNewsDetailAction, news } = props;
  const { detailLoader, detail } = news;
  const currentLanguage = getCurrentLanguage(language);

  useEffect(() => {
    setHeaderTitle(detail?.description.title[currentLanguage]);
  }, [setHeaderTitle, news, currentLanguage, detail]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    getNewsDetailAction(Number(id));
  }, [getNewsDetailAction, id]);

  return (
    <CompWrapper>
      <CardWrapper>
        <ActivityIndicator animating={detailLoader}>
          {detail && (
            <div className="news-detail-wrapper">
              <div className="container">
                <div className="detail">
                  <div className="title">
                    {detail.description.title[currentLanguage]}
                  </div>
                  <div className="image">
                    <DetailCarousel data={detail?.images} />
                  </div>
                  <div
                    className="paragraph"
                    dangerouslySetInnerHTML={{
                      __html: detail.description.desc[currentLanguage],
                    }}
                  />
                  <a
                    href={detail.link}
                    target="_blank"
                    rel="noopener noreferrer">
                    {detail?.link}
                  </a>
                </div>
              </div>
            </div>
          )}
        </ActivityIndicator>
      </CardWrapper>
    </CompWrapper>
  );
};

const mapStateToProps = (state) => {
  return {
    news: state.news,
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getNewsDetailAction,
    },
    dispatch,
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(NewsDetailPage);
